import { useState, useMemo } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:8001/api/v1";
// OSM (tile.openstreetmap.org) limita peticiones desde la IP del servidor GCP en
// producción — recuadros grises sin cargar. Con clave configurada, el mapa de
// torres/celdas usa Google en vez de OSM; sin clave, cae de vuelta a OSM igual que antes.
const GOOGLE_MAPS_JS_KEY = process.env.REACT_APP_GOOGLE_MAPS_JS_KEY || "";

function SeccionHerramientas({ termino }) {
  const q = encodeURIComponent(termino || "");
  const herramientas = [
    {
      categoria: "Geolocalización Celular",
      items: [
        { nombre: "OpenCelliD", url: "https://opencellid.org/#zoom=12&lat=19.4&lon=-99.1" },
        { nombre: "CellMapper", url: "https://www.cellmapper.net/map" },
        { nombre: "Mozilla Location", url: "https://location.services.mozilla.com/map#2/35.0/9.0" },
      ]
    },

    {
      categoria: "Numeración Telefónica México",
      items: [
        { nombre: "ABC Teléfonos MX", url: "https://www.abctelefonos.com/search?q=" + q + "&l=&t=telefono&country=mexico" },
        { nombre: "SNS IFT Numeración", url: "https://sns.ift.org.mx:8081/sns-frontend/consulta-numeracion/numeracion-geografica.xhtml" },
        { nombre: "IFT Portabilidad", url: "https://www.ift.org.mx/usuarios-y-audiencias/portabilidad" },
        { nombre: "TELMEX Directorio", url: "https://www.telmex.com/web/superpaginas" },
      ]
    },

    {
      categoria: "Geolocalización WiFi",
      items: [
        { nombre: "Wigle.net", url: "https://wigle.net/map" },
        { nombre: "OpenWiFiMap", url: "https://openwifimap.net" },
      ]
    },
    {
      categoria: "Rastreo Aéreo",
      items: [
        { nombre: "FlightRadar24", url: "https://www.flightradar24.com/19.43,-99.13/8" },
        { nombre: "FlightAware", url: "https://flightaware.com" },
        { nombre: "ADS-B Exchange", url: "https://globe.adsbexchange.com" },
        { nombre: "OpenSky Network", url: "https://opensky-network.org/network/explorer" },
      ]
    },
    {
      categoria: "Rastreo Marítimo",
      items: [
        { nombre: "MarineTraffic", url: "https://www.marinetraffic.com/en/ais/home/centerx:-90/centery:18/zoom:6" },
        { nombre: "VesselFinder", url: "https://www.vesselfinder.com" },
        { nombre: "AIS Live", url: "https://www.aislive.com" },
      ]
    },
    {
      categoria: "Imágenes Satelitales",
      items: [
        { nombre: "Sentinel Hub", url: "https://apps.sentinel-hub.com/eo-browser" },
        { nombre: "Google Earth", url: "https://earth.google.com/web" },
        { nombre: "Copernicus", url: "https://browser.dataspace.copernicus.eu" },
        { nombre: "NASA WorldView", url: "https://worldview.earthdata.nasa.gov" },
      ]
    },
    {
      categoria: "Radiofrecuencias",
      items: [
        { nombre: "RadioReference", url: "https://www.radioreference.com/apps/db/?ctid=2929" },
        { nombre: "OpenSky", url: "https://opensky-network.org" },
        { nombre: "ACARS", url: "https://app.airframes.io" },
      ]
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      {herramientas.map(function(cat, i) {
        return (
          <div key={i} className="border border-gray-200 rounded-lg p-4">
            <h3 className="font-semibold text-gray-700 mb-3">{cat.categoria}</h3>
            <div className="flex flex-wrap gap-2">
              {cat.items.map(function(item, j) {
                return (
                  <a key={j} href={item.url} target="_blank" rel="noreferrer"
                    className="text-sm bg-indigo-50 hover:bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full">
                    {item.nombre}
                  </a>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function SigintPanel() {
  const [tab, setTab] = useState("cellid");
  const [cargando, setCargando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState(null);

  const [celda, setCelda] = useState({ mcc: 334, mnc: 20, lac: "", cellid: "", radio: "GSM" });
  const [coords, setCoords] = useState({ latitud: "", longitud: "", radio_metros: 800 });
  const [cdrTexto, setCdrTexto] = useState("");

  async function buscarCelda() {
    setCargando(true);
    setError(null);
    setResultado(null);
    try {
      const res = await axios.post(
        API + "/sigint/celda",
        { ...celda, lac: parseInt(celda.lac), cellid: parseInt(celda.cellid) },
        { withCredentials: true }
      );
      setResultado(res.data);
    } catch (e) {
      setError("Error consultando OpenCelliD");
    } finally {
      setCargando(false);
    }
  }

  async function buscarCoordenadas() {
    setCargando(true);
    setError(null);
    setResultado(null);
    try {
      const res = await axios.post(
        API + "/sigint/coordenadas",
        {
          latitud: parseFloat(coords.latitud),
          longitud: parseFloat(coords.longitud),
          radio_metros: parseInt(coords.radio_metros)
        },
        { withCredentials: true }
      );
      setResultado(res.data);
    } catch (e) {
      setError("Error consultando coordenadas");
    } finally {
      setCargando(false);
    }
  }

  async function enriquecerCDR() {
    setCargando(true);
    setError(null);
    setResultado(null);
    try {
      const registros = JSON.parse(cdrTexto);
      const res = await axios.post(
        API + "/sigint/enriquecer-cdr",
        { registros },
        { withCredentials: true }
      );
      setResultado(res.data);
    } catch (e) {
      setError("Error procesando CDR. Verifica el formato JSON.");
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mt-6">
      <h2 className="text-xl font-bold text-gray-800 mb-1">📡 Panel SIGINT</h2>
      <p className="text-gray-500 text-sm mb-4">
        Análisis de señales e infraestructura de telecomunicaciones
      </p>

      <div className="flex gap-2 mb-6 flex-wrap">
        {[
          { id: "cellid", label: "🗼 Consulta CellID" },
          { id: "coordenadas", label: "📍 Por Coordenadas" },
          { id: "cdr", label: "📱 Enriquecer CDR" },
          { id: "herramientas", label: "🔧 Herramientas" },
        ].map(function(t) {
          return (
            <button key={t.id}
              onClick={function() { setTab(t.id); setResultado(null); setError(null); }}
              className={"px-4 py-2 rounded-lg text-sm font-medium " + (tab === t.id ? "bg-indigo-700 text-white" : "bg-gray-100 text-gray-700")}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === "cellid" && (
        <div>
          <p className="text-gray-600 text-sm mb-4">
            Consulta datos técnicos de una torre celular por sus identificadores MCC/MNC/LAC/CellID.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-4">
            {[
              { label: "MCC (México=334)", campo: "mcc" },
              { label: "MNC (Telcel=20, AT&T=90)", campo: "mnc" },
              { label: "LAC", campo: "lac" },
              { label: "Cell ID", campo: "cellid" },
            ].map(function(f) {
              return (
                <div key={f.campo}>
                  <label className="text-gray-600 text-xs mb-1 block">{f.label}</label>
                  <input type="number" value={celda[f.campo]}
                    onChange={function(e) { setCelda(function(c) { return { ...c, [f.campo]: e.target.value }; }); }}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                  />
                </div>
              );
            })}
            <div>
              <label className="text-gray-600 text-xs mb-1 block">Radio</label>
              <select value={celda.radio}
                onChange={function(e) { setCelda(function(c) { return { ...c, radio: e.target.value }; }); }}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
              >
                <option>GSM</option>
                <option>UMTS</option>
                <option>LTE</option>
                <option>NR</option>
              </select>
            </div>
          </div>
          <button onClick={buscarCelda} disabled={cargando}
            className="bg-indigo-700 hover:bg-indigo-800 text-white px-6 py-2 rounded-lg font-medium disabled:opacity-50">
            {cargando ? "Consultando..." : "Consultar Torre"}
          </button>
        </div>
      )}

      {tab === "coordenadas" && (
        <div>
          <p className="text-gray-600 text-sm mb-4">
            Busca torres celulares cercanas a unas coordenadas geográficas.
          </p>
          <div className="grid grid-cols-3 gap-3 mb-4">
            <div>
              <label className="text-gray-600 text-xs mb-1 block">Latitud</label>
              <input type="number" step="0.0001" value={coords.latitud}
                onChange={function(e) { setCoords(function(c) { return { ...c, latitud: e.target.value }; }); }}
                placeholder="19.4326"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs mb-1 block">Longitud</label>
              <input type="number" step="0.0001" value={coords.longitud}
                onChange={function(e) { setCoords(function(c) { return { ...c, longitud: e.target.value }; }); }}
                placeholder="-99.1332"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs mb-1 block">Radio (metros)</label>
              <input type="number" value={coords.radio_metros}
                onChange={function(e) { setCoords(function(c) { return { ...c, radio_metros: e.target.value }; }); }}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
              />
            </div>
          </div>
          <button onClick={buscarCoordenadas} disabled={cargando}
            className="bg-indigo-700 hover:bg-indigo-800 text-white px-6 py-2 rounded-lg font-medium disabled:opacity-50">
            {cargando ? "Buscando..." : "Buscar Torres Cercanas"}
          </button>
        </div>
      )}

      {tab === "cdr" && (
        <div>
          <p className="text-gray-600 text-sm mb-1">
            Carga el archivo JSON exportado desde CDR Analyzer Pro (botón <b>Exportar JSON → SIGINT</b>)
            o pega los registros directamente.
          </p>
          <p className="text-gray-400 text-xs mb-3">
            Formato: [{"{"}latitud, longitud, fecha, hora, telefono{"}"}]
          </p>
          {/* Carga desde archivo */}
          <div className="flex items-center gap-3 mb-3">
            <label className="cursor-pointer bg-violet-700 hover:bg-violet-800 text-white text-xs font-bold px-4 py-2 rounded-lg">
              📂 Cargar archivo JSON
              <input type="file" accept=".json" className="hidden"
                onChange={function(e) {
                  const file = e.target.files[0];
                  if (!file) return;
                  const reader = new FileReader();
                  reader.onload = function(ev) {
                    setCdrTexto(ev.target.result);
                  };
                  reader.readAsText(file);
                  e.target.value = "";
                }}
              />
            </label>
            <span className="text-gray-400 text-xs">o pega el JSON en el campo de abajo</span>
          </div>
          <textarea
            value={cdrTexto}
            onChange={function(e) { setCdrTexto(e.target.value); }}
            rows={6}
            placeholder='[{"latitud": 19.4326, "longitud": -99.1332, "fecha": "2024-01-01", "hora": "12:00:00"}]'
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono mb-4"
          />
          <button onClick={enriquecerCDR} disabled={cargando || !cdrTexto.trim()}
            className="bg-indigo-700 hover:bg-indigo-800 text-white px-6 py-2 rounded-lg font-medium disabled:opacity-50">
            {cargando ? "Procesando..." : "Enriquecer con OpenCelliD"}
          </button>
        </div>
      )}

      {tab === "herramientas" && <SeccionHerramientas />}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-4 mt-4 text-sm">
          {error}
        </div>
      )}

      {resultado && <ResultadoSIGINT data={resultado} tipo={tab} />}
    </div>
  );
}

// ── COMPONENTE: Resultado visual SIGINT ────────────────────────────────────

function ResultadoSIGINT({ data, tipo }) {
  const mapHtml = useMemo(() => construirMapaHtml(data, tipo), [data, tipo]);

  if (tipo === "celda") {
    // Resultado de búsqueda por CellID individual
    const enc = data.encontrado;
    return (
      <div className="mt-6 space-y-4">
        <div className={`rounded-xl border p-4 ${enc ? "border-green-200 bg-green-50" : "border-red-200 bg-red-50"}`}>
          <div className="flex items-center gap-2 mb-3">
            <span className="text-xl">{enc ? "📡" : "❌"}</span>
            <span className={`font-bold text-lg ${enc ? "text-green-700" : "text-red-700"}`}>
              {enc ? "Torre celular localizada" : "Torre no encontrada"}
            </span>
          </div>
          {enc && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
              {[
                ["Operador", data.operador],
                ["Tecnología", data.radio],
                ["País", data.pais],
                ["Fuente", data.fuente],
                ["MCC", data.mcc],
                ["MNC", data.mnc],
                ["LAC", data.lac],
                ["Cell ID", data.cellid],
                ["Latitud", data.latitud],
                ["Longitud", data.longitud],
                ["Precisión (m)", data.precision || "—"],
              ].map(([k, v]) => (
                <div key={k} className="bg-white rounded-lg p-2 border border-gray-200">
                  <div className="text-xs text-gray-400 mb-0.5">{k}</div>
                  <div className="font-mono font-semibold text-gray-800 text-sm">{v ?? "—"}</div>
                </div>
              ))}
            </div>
          )}
          {data.error && <p className="text-red-600 text-sm mt-2">{data.error}</p>}
        </div>
        {enc && (
          <iframe
            srcDoc={mapHtml}
            style={{ width: "100%", height: 320, border: "none", borderRadius: 10 }}
            title="Mapa torre celular"
          />
        )}
      </div>
    );
  }

  if (tipo === "coordenadas") {
    const celdas = data.celdas || [];
    const tieneDatos = celdas.length > 0;
    return (
      <div className="mt-6 space-y-4">
        {/* Resumen */}
        <div className="flex flex-wrap gap-3">
          {[
            ["Total torres", data.total_celdas ?? 0, "bg-indigo-100 text-indigo-700"],
            ["Radio búsqueda", `${data.radio_metros ?? 800} m`, "bg-gray-100 text-gray-700"],
            ["Fuente", data.fuente, "bg-green-100 text-green-700"],
          ].map(([label, val, cls]) => (
            <div key={label} className={`rounded-lg px-3 py-2 text-sm font-semibold ${cls}`}>
              <span className="font-normal text-xs block">{label}</span>
              {val}
            </div>
          ))}
          {data.error && (
            <div className="rounded-lg px-3 py-2 text-sm font-semibold bg-red-100 text-red-700">
              <span className="font-normal text-xs block">Advertencia</span>{data.error}
            </div>
          )}
        </div>
        {/* Mapa */}
        <iframe
          srcDoc={mapHtml}
          style={{ width: "100%", height: 350, border: "none", borderRadius: 10 }}
          title="Mapa torres cercanas"
        />
        {/* Tabla */}
        {tieneDatos && <TablaCeldas celdas={celdas} />}
      </div>
    );
  }

  // tipo === "cdr"
  const registros = data.registros_enriquecidos || [];
  const conDatos = registros.filter(r => (r.cellid_data?.celdas || []).length > 0).length;
  const totalTorres = new Set(
    registros.flatMap(r => (r.cellid_data?.celdas || []).map(c => c.cellid).filter(Boolean))
  ).size;

  return (
    <div className="mt-6 space-y-4">
      {/* Resumen */}
      <div className="flex flex-wrap gap-3">
        {[
          ["Puntos CDR", registros.length, "bg-blue-100 text-blue-700"],
          ["Con cobertura", conDatos, "bg-green-100 text-green-700"],
          ["Torres únicas", totalTorres, "bg-violet-100 text-violet-700"],
        ].map(([label, val, cls]) => (
          <div key={label} className={`rounded-lg px-3 py-2 text-sm font-semibold ${cls}`}>
            <span className="font-normal text-xs block">{label}</span>
            {val}
          </div>
        ))}
      </div>
      {/* Leyenda */}
      <div className="flex flex-wrap gap-4 text-xs text-gray-500">
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:"50%",background:"#38bdf8",marginRight:4}}/>Punto CDR</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:"50%",background:"#c084fc",marginRight:4}}/>LTE</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:"50%",background:"#4ade80",marginRight:4}}/>UMTS</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:"50%",background:"#fbbf24",marginRight:4}}/>GSM</span>
      </div>
      {/* Mapa */}
      <iframe
        srcDoc={mapHtml}
        style={{ width: "100%", height: 400, border: "none", borderRadius: 10 }}
        title="Mapa enriquecimiento CDR+SIGINT"
      />
      {/* Tabla resumen por punto */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="border-b border-gray-200 text-xs text-gray-500 uppercase">
              <th className="text-left py-2 px-3">Fecha / Hora</th>
              <th className="text-left py-2 px-3">Coordenadas</th>
              <th className="text-center py-2 px-3">Torres</th>
              <th className="text-left py-2 px-3">Operador</th>
              <th className="text-left py-2 px-3">Tecnologías</th>
              <th className="text-left py-2 px-3">Estado</th>
            </tr>
          </thead>
          <tbody>
            {registros.map(function(r, i) {
              const celdas = r.cellid_data?.celdas || [];
              const err = r.cellid_data?.error;
              const ops = [...new Set(celdas.map(c => c.operador).filter(Boolean))].join(", ") || "—";
              const reds = [...new Set(celdas.map(c => c.radio).filter(Boolean))];
              const redColors = { LTE: "#c084fc", UMTS: "#4ade80", GSM: "#fbbf24" };
              return (
                <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-2 px-3 font-mono text-xs text-gray-600">
                    {r.fecha || "—"}<br /><span className="text-gray-400">{(r.hora || "").substring(0, 8)}</span>
                  </td>
                  <td className="py-2 px-3 font-mono text-xs text-blue-600">
                    {r.latitud?.toFixed(5)},<br />{r.longitud?.toFixed(5)}
                  </td>
                  <td className="py-2 px-3 text-center font-bold">
                    <span className={celdas.length > 0 ? "text-violet-700" : "text-gray-300"}>
                      {celdas.length > 0 ? celdas.length : "—"}
                    </span>
                  </td>
                  <td className="py-2 px-3 text-xs text-gray-700">{ops}</td>
                  <td className="py-2 px-3 text-xs">
                    {reds.map(t => (
                      <span key={t} style={{ color: redColors[t] || "#94a3b8", fontWeight: 600, marginRight: 4 }}>{t}</span>
                    ))}
                    {reds.length === 0 && <span className="text-gray-300">—</span>}
                  </td>
                  <td className="py-2 px-3 text-xs">
                    {err
                      ? <span className="text-red-500">⚠️ Sin datos</span>
                      : celdas.length > 0
                      ? <span className="text-green-600">✔ {celdas.length} torre{celdas.length > 1 ? "s" : ""}</span>
                      : <span className="text-gray-400">— Sin cobertura</span>
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function TablaCeldas({ celdas }) {
  const colores = { LTE: "text-purple-700 bg-purple-50", UMTS: "text-green-700 bg-green-50", GSM: "text-yellow-700 bg-yellow-50" };
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="border-b border-gray-200 text-xs text-gray-500 uppercase">
            {["Operador", "Tecnología", "Cell ID", "LAC", "MCC/MNC", "Latitud", "Longitud"].map(h => (
              <th key={h} className="text-left py-2 px-3">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {celdas.map(function(c, i) {
            const cls = colores[c.radio] || "text-gray-700 bg-gray-50";
            return (
              <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-2 px-3 font-semibold text-gray-800">{c.operador || "—"}</td>
                <td className="py-2 px-3"><span className={`text-xs font-bold px-2 py-0.5 rounded ${cls}`}>{c.radio || "—"}</span></td>
                <td className="py-2 px-3 font-mono text-xs text-gray-600">{c.cellid}</td>
                <td className="py-2 px-3 font-mono text-xs text-gray-600">{c.lac}</td>
                <td className="py-2 px-3 font-mono text-xs text-gray-500">{c.mcc}/{c.mnc}</td>
                <td className="py-2 px-3 font-mono text-xs text-blue-600">{c.latitud?.toFixed(5)}</td>
                <td className="py-2 px-3 font-mono text-xs text-blue-600">{c.longitud?.toFixed(5)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function construirMapaHtml(data, tipo) {
  // Recopilar puntos para el mapa: [{lat, lon, tipo, label}]
  let puntosCDR = [];
  let torres = [];

  if (tipo === "celda") {
    if (data.encontrado && data.latitud && data.longitud) {
      torres.push({ lat: data.latitud, lon: data.longitud, radio: data.radio, operador: data.operador, cellid: data.cellid, lac: data.lac });
    }
  } else if (tipo === "coordenadas") {
    const cc = data.coordenadas_consulta || {};
    if (cc.latitud && cc.longitud) {
      puntosCDR.push({ lat: cc.latitud, lon: cc.longitud, label: `Punto consultado` });
    }
    (data.celdas || []).forEach(function(c) {
      if (c.latitud && c.longitud) {
        torres.push({ lat: c.latitud, lon: c.longitud, radio: c.radio, operador: c.operador, cellid: c.cellid, lac: c.lac });
      }
    });
  } else {
    // tipo === "cdr"
    (data.registros_enriquecidos || []).forEach(function(r) {
      if (r.latitud && r.longitud) {
        puntosCDR.push({ lat: r.latitud, lon: r.longitud, label: `${r.fecha || ""} ${(r.hora || "").substring(0, 8)}` });
      }
      (r.cellid_data?.celdas || []).forEach(function(c) {
        if (c.latitud && c.longitud) {
          torres.push({ lat: c.latitud, lon: c.longitud, radio: c.radio, operador: c.operador, cellid: c.cellid, lac: c.lac, puntoCDR: { lat: r.latitud, lon: r.longitud } });
        }
      });
    });
  }

  const todosPuntos = [
    ...puntosCDR.map(p => [p.lat, p.lon]),
    ...torres.map(t => [t.lat, t.lon])
  ];
  const centroLat = todosPuntos.length ? todosPuntos.reduce((s, p) => s + p[0], 0) / todosPuntos.length : 19.4;
  const centroLon = todosPuntos.length ? todosPuntos.reduce((s, p) => s + p[1], 0) / todosPuntos.length : -99.1;

  const cdrJs = JSON.stringify(puntosCDR);
  const torresJs = JSON.stringify(torres);

  return `<!DOCTYPE html><html><head>
<meta charset="UTF-8"/>
<link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"/>
<script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"><\/script>
${GOOGLE_MAPS_JS_KEY ? `<script src="https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_JS_KEY}"><\/script>
<script src="https://unpkg.com/leaflet.gridlayer.googlemutant@0.14.1/dist/Leaflet.GoogleMutant.js"><\/script>` : ''}
<style>html,body,#mapa{margin:0;padding:0;height:100%;width:100%;}</style>
</head><body>
<div id="mapa"></div>
<script>
var map=L.map('mapa',{attributionControl:false});
${GOOGLE_MAPS_JS_KEY
  ? "L.gridLayer.googleMutant({type:'roadmap',maxZoom:19}).addTo(map);"
  : "L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);"}
var bounds=[];
var cdrPts=${cdrJs};
var torres=${torresJs};
cdrPts.forEach(function(p){
  bounds.push([p.lat,p.lon]);
  L.circleMarker([p.lat,p.lon],{radius:6,color:'#0ea5e9',fillColor:'#38bdf8',fillOpacity:0.9,weight:2})
   .bindTooltip('<b>Punto CDR</b><br>'+p.label).addTo(map);
});
var colMap={LTE:'#c084fc',UMTS:'#4ade80',GSM:'#fbbf24'};
torres.forEach(function(t){
  bounds.push([t.lat,t.lon]);
  var col=colMap[t.radio]||'#94a3b8';
  L.circleMarker([t.lat,t.lon],{radius:8,color:col,fillColor:col,fillOpacity:0.8,weight:2})
   .bindTooltip('<b>📡 '+( t.radio||'Torre')+'</b><br>'+(t.operador||'—')+'<br>CellID: '+(t.cellid||'—')+'<br>LAC: '+(t.lac||'—'))
   .addTo(map);
  if(t.puntoCDR){
    L.polyline([[t.puntoCDR.lat,t.puntoCDR.lon],[t.lat,t.lon]],
      {color:col,weight:1.5,opacity:0.4,dashArray:'5,5'}).addTo(map);
  }
});
if(bounds.length){map.fitBounds(bounds,{padding:[20,20]});}
else{map.setView([${centroLat},${centroLon}],12);}
<\/script>
</body></html>`;
}